import { space, width } from 'styled-system';
import styled, { keyframes } from 'styled-components';
//////////////////////////////////////////////////

export const FormSection = styled('section')`
  ${space}
  ${width}

  display: flex;
  flex-wrap: wrap;
  position: static;

  z-index: ${({ zIndex }) => zIndex || 'initial'};
  justify-content: ${({ justifyContent }) => justifyContent};
  flex-direction: ${({ flexDirection }) => flexDirection || 'row'};
`;

const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
`;

export const PulseButton = styled('div')`
  animation: ${pulse} ease-in-out infinite both;
  animation-duration: ${({ animationDuration }) => animationDuration};

  &:hover {
    animation-duration: 0s;
  }
`;
